// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1PRex","search":"Settings_search__2hecG","filter":"Settings_filter__Ovqhm"};